/**
 * @flow
 * @relayHash e3312ddea484d9676ef0d11a52a7ada7
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type AdminAcceptJobOfferMutationVariables = {|
  input: {
    jobOfferId: string;
    clientMutationId?: ?string;
  };
|};
export type AdminAcceptJobOfferMutationResponse = {|
  +adminAcceptJob: ?{|
    +clientMutationId: ?string;
    +job: ?{|
      +acceptedJobOffer: {|
        +jobRequest: {|
          +status: string;
          +offers: $ReadOnlyArray<{|
            +status: string;
          |}>;
        |};
        +status: string;
      |};
    |};
  |};
|};
*/


/*
mutation AdminAcceptJobOfferMutation(
  $input: AdminForceJobCreationInput!
) {
  adminAcceptJob(input: $input) {
    clientMutationId
    job {
      acceptedJobOffer {
        jobRequest {
          status
          offers {
            status
            id
          }
          id
        }
        status
        id
      }
      id
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "AdminForceJobCreationInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminAcceptJobOfferMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "AdminForceJobCreationInput!"
          }
        ],
        "concreteType": "AdminForceJobCreationPayload",
        "name": "adminAcceptJob",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "clientMutationId",
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Job",
            "name": "job",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "JobOffer",
                "name": "acceptedJobOffer",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "JobRequest",
                    "name": "jobRequest",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "JobOffer",
                        "name": "offers",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "status",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "status",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "AdminAcceptJobOfferMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "AdminForceJobCreationInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "AdminAcceptJobOfferMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "AdminForceJobCreationInput!"
          }
        ],
        "concreteType": "AdminForceJobCreationPayload",
        "name": "adminAcceptJob",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "clientMutationId",
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Job",
            "name": "job",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "JobOffer",
                "name": "acceptedJobOffer",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "JobRequest",
                    "name": "jobRequest",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "JobOffer",
                        "name": "offers",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation AdminAcceptJobOfferMutation(\n  $input: AdminForceJobCreationInput!\n) {\n  adminAcceptJob(input: $input) {\n    clientMutationId\n    job {\n      acceptedJobOffer {\n        jobRequest {\n          status\n          offers {\n            status\n            id\n          }\n          id\n        }\n        status\n        id\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/mutations/__generated__/AdminAcceptJobOfferMutation.graphql.js